import { Modal } from 'antd'

export const useModal = Modal.useModal
